import { sessionUser } from 'utility/sessionStorageHelper';
import { FEATURE_FLAGS } from 'config';

export const transactionURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `transactionsvc/v0/cust/${customerId}/user/${userId}/` + endpoint;
};

export const archiveTransactionURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `archivesvc/v0/cust/${customerId}/user/${userId}/` + endpoint;
};

export const decisionManagerURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `txndecisionmanagersvc/v0/cust/${customerId}/user/${userId}/` + endpoint;
};

export const imageOrchestrationURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `imageorchestratorsvc/v0/cust/${customerId}/user/${userId}/` + endpoint;
};

/**
 * Routes image viewer API requests based on the env-config feature flag.
 * false → transactionsvc       (default)
 * true  → imageorchestratorsvc (window.USE_IMAGE_ORCHESTRATION_SERVICE)
 *
 * DevOps controls this flag per-environment in env-config.*.js — no code deployment required.
 *
 * Used by the image get/save/thumbnail endpoints in Components/Image/Viewer/actions.js ONLY.
 * Transaction note endpoints and all other endpoints stay on transactionsvc permanently
 * and must NOT use this function.
 */
export const toggledImageURL = endpoint =>
  FEATURE_FLAGS.USE_IMAGE_ORCHESTRATION_SERVICE
    ? imageOrchestrationURL(endpoint)
    : transactionURL(endpoint);
